import { render, staticRenderFns } from "./SelectProjectBusiness.vue?vue&type=template&id=5490d3be&"
import script from "./SelectProjectBusiness.vue?vue&type=script&lang=js&"
export * from "./SelectProjectBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports